export default "__VITE_ASSET__DG2sF7O0__"